export default function BenefitsGrid() {
  const benefits = [
    { title: "Save up to 60% sourcing time", desc: "Skip the manual browsing and jump directly to verified product lists with instant supplier data.", icon: "ri-timer-flash-line" },
    { title: "Access verified product data", desc: "Every entry in the itaobuy spreadsheet is pre-checked and organized for real-world dropshipping use.", icon: "ri-verified-badge-line" },
    { title: "Reduce supplier risk", desc: "Work with data from established suppliers rather than gambling on unverified marketplace listings.", icon: "ri-shield-star-line" },
    { title: "Improve dropshipping efficiency", desc: "Streamline your entire product research pipeline from discovery to purchase in one workflow.", icon: "ri-rocket-2-line" },
    { title: "Scale product research faster", desc: "Browse 14 categories simultaneously and compare hundreds of products without tab overload.", icon: "ri-stack-fill" },
    { title: "14 curated categories", desc: "From Shoes to Perfumes, every major dropshipping niche is covered with regularly updated sheets.", icon: "ri-grid-line" },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm font-medium text-foreground-500 tracking-[0.15em] uppercase mb-3 whitespace-nowrap">
            Key Advantages
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Key Benefits of
            <br />
            ItaobuySpreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((b) => (
            <div key={b.title} className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/50 hover:border-accent-200 transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${b.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">{b.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}